import { useLocation } from '@tanstack/react-router';
import { studyLibraryFromPath, type StudyLibrary } from '../../-data/constants';

/**
 * Which product library the current study detail route is being read under.
 *
 * Read from the pathname rather than from a route id or a prop: the study
 * chrome is mounted by more than one route (ENG-1190 bans pinning `from:` in
 * `-components/**`), and every one of them already puts the answer in the URL.
 * Callers use it to keep an in-study navigation inside the library the reader
 * came from — see `ANALYZE_MODE_ROUTES`, which is keyed by it.
 */
export function useStudyLibrary(): StudyLibrary {
  return useLocation({ select: (l) => studyLibraryFromPath(l.pathname) });
}
